import * as React from "react"
import { Link } from "react-router-dom"
import { Action, mk_widget, Widget } from "widgets-for-react"
import { LoginState, ResetPasswordState, isResetPasswordState, ResetPasswordSuccessState, isResetPasswordSuccessState, User } from "../state"
import { notifications } from '../notifications';
import { Api } from '../api_to_state';
import { MinimalLoginWidgetData, update_state_with_route } from "../login";
import { LoginFlowStyle, LoginFlowClasses } from "./style.mod";
import { getClassName } from "../../utils/utils.mod";
import i18next = require("i18next");

function handleSubmit<a, extra_user_info>(e: React.FormEvent<HTMLFormElement>, setState: (_: Action<LoginState<a, extra_user_info>>) => void, api: Api<extra_user_info>) {
  e.preventDefault();
  setState(s => isResetPasswordState(s)
    ? s.login_data.password == s.login_data.confirmed_password
      ? ({ status: "reset password - resetting password", login_data: s.login_data })
      : ({
        ...s,
        login_data:
        {
          ...s.login_data,
          password: s.login_data.password == undefined
            ? ""
            : s.login_data.password, reset_password_token: s.login_data.reset_password_token == undefined
              ? ""
              : s.login_data.reset_password_token
        }
      })
    : s);
}

export function reset_password_form<a, extra_user_info>(
  data: MinimalLoginWidgetData<a, extra_user_info>,
  options?: { style?: LoginFlowStyle; key?: string }
) {
  return (s0: ResetPasswordState, readonly: boolean, rootpath: string, api?: Api<extra_user_info>): Widget<Action<LoginState<a, extra_user_info>>> => {
    let password_error = s0.status == "reset password - error weak password"
    let confirmed_password_error = s0.login_data.password != undefined && s0.login_data.confirmed_password != s0.login_data.password;
    return mk_widget({
      run: (setState: (_: Action<LoginState<a, extra_user_info>>) => void) => {
        return (
          <section className={getClassName(options, "block_classname", "container")} key="login-widget-reset-password-form">
            <header className={getClassName(options, "header_classname", "mb-4")}>
              <Link className="header__link" to={`${rootpath}`}>
                <h1 className={getClassName(options, "title_classname", "mb-4")}>{i18next.t(`loginflow:reset_password.title`)}</h1>
                <svg className="header__logo" width="120" height="32" aria-hidden="true">
                  <use xlinkHref="#icon--logo" />
                </svg>
              </Link>
            </header>

            <div className={getClassName(options, "inner_classname", "py-5")}>
              <form onSubmit={(e) => handleSubmit(e, setState, api)} className={getClassName(options, "form_classname", "")}>
                <div className={getClassName(options, "form_inner_classname", "")}>

                  <div className={getClassName(options, "form_group_classname", "form-group")}>
                    <label
                      htmlFor="password"
                      className={getClassName(options, "form_label_classname", "")}
                    >
                      {i18next.t(`loginflow:reset_password.fields.password`)}
                    </label>
                    <input
                      type={s0.login_data.show_password ? "text" : "password"}
                      name="password"
                      id="password"
                      aria-invalid={password_error}
                      aria-describedby={password_error ? "a11y-password-error" : null}
                      className={getClassName(options, "form_input_classname", `form-control ${password_error ? "is-invalid" : ""}`)}
                      value={s0.login_data.password}
                      disabled={readonly}
                      onChange={(event) => setState(s => isResetPasswordState(s) ? ({
                        ...s,
                        status: "reset password",
                        login_data: {
                          ...s.login_data,
                          password: event.currentTarget.value
                        }
                      }) : s)
                      }
                    />
                    {/* Password toggle */}
                    <div className="form__password-toggle">                    
                      <input
                        type="checkbox"
                        name="show_password"
                        id="show_password1"
                        className={getClassName(options, "form_checkbox_classname", "form-check-input")}
                        checked={s0.login_data.show_password}
                        disabled={readonly}
                        tabIndex={-1}
                        onChange={(event) => setState(s => isResetPasswordState(s) ? ({
                          ...s,
                          status: "reset password",
                          login_data: {
                            ...s.login_data,
                            show_password: event.target.checked
                          }
                        }) : s)}
                      />
                      <label htmlFor="show_password1">
                        <span className="sr-text">{i18next.t(`loginflow:reset_password.fields.show_password_checkbox`)}</span>
                        <svg className="form__password-icon form__password-icon--on" aria-hidden="true">
                          <use xlinkHref="#icon--eye" />
                        </svg>
                        <svg className="form__password-icon form__password-icon--off" aria-hidden="true">
                          <use xlinkHref="#icon--eye-off" />
                        </svg>
                      </label>
                    </div>
                  </div>

                  <div className={getClassName(options, "form_group_classname", "form-group")}>
                    <label
                      htmlFor="confirm-password"
                      className={getClassName(options, "form_label_classname", "")}
                    >
                      {i18next.t(`loginflow:reset_password.fields.password_confirmed`)}
                    </label>
                    <input
                      type={s0.login_data.show_password ? "text" : "password"}
                      name="confirm-password"
                      id="confirm-password"
                      aria-invalid={confirmed_password_error}
                      aria-describedby={confirmed_password_error ? "a11y-confirm-password-error" : null}
                      className={getClassName(options, "form_input_classname", `form-control ${confirmed_password_error ? "is-invalid" : ""}`)}
                      value={s0.login_data.confirmed_password}
                      disabled={readonly}
                      onChange={(event) => setState(s => isResetPasswordState(s) ? ({
                        ...s,
                        status: "reset password",
                        login_data: {
                          ...s.login_data,
                          confirmed_password: event.currentTarget.value
                        }
                      }) : s)
                      }
                    />

                    {/* Password toggle */}
                    <div className="form__password-toggle">                    
                      <input
                        type="checkbox"
                        name="show_password"
                        id="show_password2"
                        className={getClassName(options, "form_checkbox_classname", "form-check-input")}
                        checked={s0.login_data.show_password}
                        disabled={readonly}
                        tabIndex={-1}
                        onChange={(event) => setState(s => isResetPasswordState(s) ? ({
                          ...s,
                          status: "reset password",
                          login_data: {
                            ...s.login_data,
                            show_password: event.target.checked
                          }
                        }) : s)}
                      />
                      <label htmlFor="show_password2">
                        <span className="sr-text">{i18next.t(`loginflow:reset_password.fields.show_password_checkbox`)}</span>
                        <svg className="form__password-icon form__password-icon--on" aria-hidden="true">
                          <use xlinkHref="#icon--eye" />
                        </svg>
                        <svg className="form__password-icon form__password-icon--off" aria-hidden="true">
                          <use xlinkHref="#icon--eye-off" />
                        </svg>
                      </label>
                    </div>

                    {confirmed_password_error && (
                      <p id="a11y-confirm-password-error" className={getClassName(options, "form_input_error_classname", "invalid-feedback d-block")}>
                        {i18next.t(`loginflow:reset_password.fields.password_confirmed_invalid`)}
                      </p>
                    )}
                  </div>

                  {notifications(s0, { style: LoginFlowClasses }).run(() => s => s)}

                  <p className={getClassName(options, "form_description_classname", "lead")}>{i18next.t(`loginflow:reset_password.text`)}</p>

                  <div className={getClassName(options, "form_actions_classname", "")}>
                    <button
                      type="submit"
                      className={getClassName(options, "clickable_primary_classname", "btn btn-dark")}
                      disabled={readonly}
                    >
                      {i18next.t(`loginflow:reset_password.clickables.submit`)}
                    </button>


                    <footer className={getClassName(options, "footer_classname", "")}>
                      {data.without_browserRouter
                        ? <button
                            type="button"
                            className={getClassName(options, "clickable_secondary_classname", "btn btn-link")}
                            onClick={() => setState(update_state_with_route({ kind: "home" }, data))}
                          >
                            {i18next.t(`loginflow:reset_password.clickables.cancel`)}
                          </button>
                        : <Link
                            to={rootpath}
                            className={getClassName(options, "clickable_secondary_classname", "btn btn-link")}
                          >
                            {i18next.t(`loginflow:reset_password.clickables.cancel`)}
                          </Link>
                      }
                    </footer>
                  </div>
                </div>
              </form>
            </div>
          </section>
        )
      }
    })
  }
}

export function reset_password_success<a, extra_user_info>(options?: { style?: LoginFlowStyle; key?: string }) {
  return (s0: ResetPasswordSuccessState, readonly: boolean, rootpath: string): Widget<Action<LoginState<a, extra_user_info>>> => {
    return mk_widget({
      run: (setState: (_: Action<LoginState<a, extra_user_info>>) => void) => {
        return (
          <section className={getClassName(options, "block_classname", "container")} key="login-widget-reset-password-request-success">
            <header className={getClassName(options, "header_classname", "mb-4")}>
              <Link className="header__link" to={`${rootpath}`}>
                <h1 className={getClassName(options, "title_classname", "mb-4")}>{i18next.t(`loginflow:reset_password_success.title`)}</h1>
                <svg className="header__logo" width="120" height="32" aria-hidden="true">
                  <use xlinkHref="#icon--logo" />
                </svg>
              </Link>
            </header>

            <div className={getClassName(options, "inner_classname", "py-5")}>
              <div className={getClassName(options, "form_classname", "")}>
                <div className={getClassName(options, "form_inner_classname", "")}>
                <p className={getClassName(options, "intro_classname", "lead")}>{i18next.t(`loginflow:reset_password_success.text`)}</p>
                <footer className={getClassName(options, "form_actions_classname", "")}>
                  <button
                    className={getClassName(options, "clickable_primary_classname", "btn btn-dark")}
                    disabled={readonly}
                    onClick={() => setState(s => isResetPasswordSuccessState(s) ? { ...s, status: "reset password success - logging in" } : s)}
                  >
                    {i18next.t(`loginflow:reset_password_success.clickables.submit`)}
                  </button>
                </footer>
                </div>
              </div>
            </div>
          </section>
        )
      }
    })
  }
}
